import SearchBar from 'components/common/dataTable/searchBar'
import PendingErpSyncOrdersTable from 'components/pendingErpSync/pendingErpSyncOrdersTable'
import { Helmet } from 'react-helmet'

const PendingErpSyncOrders = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Failed Order</title>
      </Helmet>

      <div
        className={
          'mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap'
        }
      >
        <h3 className="title">Failed ERP Sync Orders</h3>
        <SearchBar placeholder="Search by Order Number" />
      </div>

      <PendingErpSyncOrdersTable />
    </>
  )
}

export default PendingErpSyncOrders
